(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["alvaro-benefit-callouts"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.alvaro-callouts').forEach(function (root) {
      var navItems = root.querySelectorAll('[data-callout-nav]');
      var markers = root.querySelectorAll('.alvaro-callouts__marker');
      var entries = root.querySelectorAll('.alvaro-callouts__entry');
      if (!markers.length) return;

      function activate(id) {
        navItems.forEach(function (n) { n.classList.toggle('is-active', n.dataset.calloutNav === id); });
        markers.forEach(function (m) {
          var active = m.dataset.callout === id;
          m.classList.toggle('is-active', active);
          m.setAttribute('aria-expanded', active ? 'true' : 'false');
        });
        entries.forEach(function (e) { e.classList.toggle('is-active', e.dataset.calloutEntry === id); });
        var activeNav = root.querySelector('[data-callout-nav="' + id + '"]');
        if (activeNav && activeNav.scrollIntoView) {
          activeNav.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }
      }

      navItems.forEach(function (n) {
        n.addEventListener('click', function () { activate(n.dataset.calloutNav); });
      });
      markers.forEach(function (m) {
        m.addEventListener('click', function () { activate(m.dataset.callout); });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["alvaro-delivery-estimate"] && !Shopify.designMode) return;
  try {
    (function () {
    // ===== Zonas de Colombia por tiempo de entrega =====
    // Clasificacion de buena fe basada en cobertura tipica de transportadoras
    // nacionales — no es exhaustiva. Ciudad no listada -> "intermedia" por
    // defecto (ni la mas rapida ni la mas lenta, para no prometer de mas ni
    // de menos). Este objeto RANGES es la UNICA fuente de verdad: de aqui
    // sale tanto el texto "X-Y dias habiles" como el calculo de fechas.
    var PRINCIPALES = ['bogota','medellin','cali','barranquilla','cartagena','bucaramanga','cucuta','pereira','ibague','manizales','santa marta','villavicencio','pasto','monteria','neiva','armenia','popayan','valledupar','sincelejo','tunja','soacha','bello','itagui','envigado','soledad','palmira','buenaventura','floridablanca','giron','piedecuesta','rionegro'];
    var APARTADAS = ['leticia','puerto inirida','mitu','puerto carreno','san andres','providencia','tumaco','guapi','el charco','bajo baudo','la macarena','miraflores','la chorrera','uribia','maicao','barrancominas','taraira','pacoa','papunaua','morichal'];

    var RANGES = {
      principal: { min: 2, max: 4 },
      intermedia: { min: 3, max: 6 },
      apartada: { min: 5, max: 10 }
    };

    function normalize(str) {
      return (str || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .trim();
    }

    function classify(city) {
      var n = normalize(city);
      if (PRINCIPALES.indexOf(n) !== -1) return 'principal';
      if (APARTADAS.indexOf(n) !== -1) return 'apartada';
      return 'intermedia';
    }

    function titleCase(str) {
      return (str || '').replace(/\w\S*/g, function (t) {
        return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase();
      });
    }

    function daysRangeText(tier) {
      var r = RANGES[tier];
      return r.min + '–' + r.max + ' días hábiles aproximadamente';
    }

    // ===== Festivos de Colombia (calculo puro en JS, sin dependencias) =====
    // Pascua: algoritmo de Meeus/Jones/Butcher (estandar, sin tablas externas).
    function easterSunday(year) {
      var a = year % 19;
      var b = Math.floor(year / 100);
      var c = year % 100;
      var d = Math.floor(b / 4);
      var e = b % 4;
      var f = Math.floor((b + 8) / 25);
      var g = Math.floor((b - f + 1) / 3);
      var h = (19 * a + b - d - g + 15) % 30;
      var i = Math.floor(c / 4);
      var k = c % 4;
      var l = (32 + 2 * e + 2 * i - h - k) % 7;
      var m = Math.floor((a + 11 * h + 22 * l) / 451);
      var month = Math.floor((h + l - 7 * m + 114) / 31);
      var day = ((h + l - 7 * m + 114) % 31) + 1;
      return new Date(year, month - 1, day);
    }
    function addDays(date, n) {
      var d = new Date(date);
      d.setDate(d.getDate() + n);
      return d;
    }
    // Ley Emiliani: si el festivo no cae en lunes, se traslada al lunes siguiente.
    function moveToMonday(date) {
      var d = new Date(date);
      while (d.getDay() !== 1) d = addDays(d, 1);
      return d;
    }
    function dateKey(d) {
      return d.getFullYear() + '-' + d.getMonth() + '-' + d.getDate();
    }
    function colombianHolidaySet(years) {
      var set = {};
      years.forEach(function (year) {
        var fixed = [[0, 1], [4, 1], [6, 20], [7, 7], [11, 8], [11, 25]];
        var emiliani = [[0, 6], [2, 19], [5, 29], [7, 15], [9, 12], [10, 1], [10, 11]];
        fixed.forEach(function (md) { set[dateKey(new Date(year, md[0], md[1]))] = true; });
        emiliani.forEach(function (md) { set[dateKey(moveToMonday(new Date(year, md[0], md[1])))] = true; });
        var easter = easterSunday(year);
        set[dateKey(addDays(easter, -3))] = true; // Jueves Santo
        set[dateKey(addDays(easter, -2))] = true; // Viernes Santo
        set[dateKey(moveToMonday(addDays(easter, 39)))] = true; // Ascension
        set[dateKey(moveToMonday(addDays(easter, 60)))] = true; // Corpus Christi
        set[dateKey(moveToMonday(addDays(easter, 68)))] = true; // Sagrado Corazon
      });
      return set;
    }
    function isBusinessDay(date, holidaySet) {
      var day = date.getDay();
      if (day === 0 || day === 6) return false;
      if (holidaySet[dateKey(date)]) return false;
      return true;
    }
    function addBusinessDays(startDate, n, holidaySet) {
      var d = new Date(startDate);
      var count = 0;
      while (count < n) {
        d = addDays(d, 1);
        if (isBusinessDay(d, holidaySet)) count++;
      }
      return d;
    }

    // ===== Formato de fecha en español =====
    var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
    var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

    function formatRange(minDate, maxDate) {
      var thisYear = new Date().getFullYear();
      var sameMonth = minDate.getMonth() === maxDate.getMonth() && minDate.getFullYear() === maxDate.getFullYear();

      function label(d, withMonth, withYear) {
        var s = DIAS[d.getDay()] + ' ' + d.getDate();
        if (withMonth) s += ' de ' + MESES[d.getMonth()];
        if (withYear) s += ' de ' + d.getFullYear();
        return s;
      }

      var minYr = minDate.getFullYear() !== thisYear;
      var maxYr = maxDate.getFullYear() !== thisYear;

      if (sameMonth) {
        return 'Entre el ' + label(minDate, false, false) + ' y el ' + label(maxDate, true, maxYr);
      }
      return 'Entre el ' + label(minDate, true, minYr) + ' y el ' + label(maxDate, true, maxYr);
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-alvaro-delivery]').forEach(function (root) {
        var result = root.querySelector('.alvaro-delivery__result');
        var cityEl = root.querySelector('[data-delivery-city]');
        var cityNameEl = root.querySelector('[data-delivery-city-name]');
        var dateEl = root.querySelector('[data-delivery-date]');
        var fallbackEl = root.querySelector('[data-delivery-fallback]');
        var daysEl = root.querySelector('[data-delivery-days]');
        var pinEl = root.querySelector('[data-delivery-pin]');
        if (!result || !cityEl || !dateEl || !fallbackEl || !daysEl) return;

        var controller = new AbortController();
        var timeout = setTimeout(function () { controller.abort(); }, 3500);

        fetch('https://ipwho.is/', { signal: controller.signal })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            clearTimeout(timeout);
            // Sin ciudad real detectada (fetch fallido, IP no resuelta, o
            // visitante fuera de Colombia) -> se queda en el mensaje
            // generico ya presente en el HTML. Nunca se inventa ciudad/fecha.
            if (!data || data.success === false) return;
            if (normalize(data.country) !== 'colombia') return;
            if (!data.city) return;

            var tier = classify(data.city);
            var today = new Date();
            var years = [today.getFullYear(), today.getFullYear() + 1];
            var holidays = colombianHolidaySet(years);
            var minDate = addBusinessDays(today, RANGES[tier].min, holidays);
            var maxDate = addBusinessDays(today, RANGES[tier].max, holidays);

            result.classList.add('is-updating');
            setTimeout(function () {
              cityNameEl.textContent = titleCase(data.city);
              cityEl.hidden = false;
              dateEl.textContent = formatRange(minDate, maxDate);
              dateEl.hidden = false;
              fallbackEl.hidden = true;
              daysEl.textContent = daysRangeText(tier);
              result.classList.remove('is-updating');
              if (pinEl) {
                pinEl.classList.add('is-located');
                setTimeout(function () { pinEl.classList.remove('is-located'); }, 550);
              }
            }, 250);
          })
          .catch(function () {
            /* deteccion fallida: se queda en el mensaje generico, sin inventar nada */
          });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["alvaro-hotspots"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.alvaro-hotspots').forEach(function (root) {
      var dots = root.querySelectorAll('.alvaro-hotspots__dot');
      var entries = root.querySelectorAll('.alvaro-hotspots__entry');
      var hint = root.querySelector('[data-hotspot-hint]');

      function activate(id) {
        dots.forEach(function (d) {
          var active = d.dataset.hotspot === id;
          d.setAttribute('aria-expanded', active ? 'true' : 'false');
          d.classList.toggle('is-active', active);
          var num = d.querySelector('.alvaro-hotspots__dot-num');
          if (num) num.classList.toggle('is-active', active);
        });
        entries.forEach(function (e) { e.classList.toggle('is-active', e.dataset.hotspotEntry === id); });
        if (hint) hint.style.opacity = '0';
        var target = root.querySelector('[data-hotspot-entry="' + id + '"]');
        if (target && window.innerWidth < 750) {
          target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { activate(dot.dataset.hotspot); });
        // feedback táctil explícito — más consistente que :active puro en algunos navegadores móviles
        dot.addEventListener('touchstart', function () { dot.classList.add('is-pressed'); }, { passive: true });
        ['touchend', 'touchcancel'].forEach(function (evt) {
          dot.addEventListener(evt, function () { dot.classList.remove('is-pressed'); }, { passive: true });
        });
      });
      entries.forEach(function (entry) {
        entry.addEventListener('click', function () { activate(entry.dataset.hotspotEntry); });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["alvaro-rating-badge"] && !Shopify.designMode) return;
  try {
    (function () {
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    ready(function () {
      document.querySelectorAll('[data-alvaro-rating]').forEach(function (root) {
        var starsEl = root.querySelector('[data-rating-stars]');
        var done = false;

        function run() {
          if (done) return;
          done = true;
          if (starsEl) starsEl.classList.add('is-visible');
        }

        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                run();
                io.unobserve(entry.target);
              }
            });
          }, { threshold: 0.4 });
          io.observe(root);
        } else {
          run();
        }

        // Encuentra el contenedor que realmente scrollea hasta el destino: en la
        // mayoría de temas es la ventana, pero Horizon puede envolver la página en
        // un contenedor interno con su propio scroll (mientras html/body quedan
        // fijos para el header sticky). Sin esto, window.scrollTo() no mueve nada.
        function getScrollParent(el) {
          var parent = el.parentElement;
          while (parent) {
            var cs = getComputedStyle(parent);
            if ((cs.overflowY === 'auto' || cs.overflowY === 'scroll') && parent.scrollHeight > parent.clientHeight) {
              return parent;
            }
            parent = parent.parentElement;
          }
          return document.scrollingElement || document.documentElement;
        }

        // todo el bloque lleva a testimonios — click, tap y teclado (button nativo)
        root.addEventListener('click', function () {
          var dest = document.getElementById(root.dataset.ratingScrollTarget || 'alvaro-testimonials');
          if (!dest) return;

          // compensa cualquier header realmente fijo/sticky anclado arriba (si existiera)
          var offset = 16;
          document.querySelectorAll('header, [class*="sticky" i]').forEach(function (el) {
            var cs = getComputedStyle(el);
            if ((cs.position === 'fixed' || cs.position === 'sticky') && el.getBoundingClientRect().top <= 5 && el.offsetHeight) {
              offset = Math.max(offset, el.offsetHeight + 16);
            }
          });

          var scrollParent = getScrollParent(dest);
          var isWindowScroll = scrollParent === document.documentElement || scrollParent === document.body;
          var currentScrollTop = isWindowScroll ? window.pageYOffset : scrollParent.scrollTop;
          var top = dest.getBoundingClientRect().top + currentScrollTop - offset;

          if (isWindowScroll) {
            window.scrollTo({ top: top, behavior: 'smooth' });
          } else {
            scrollParent.scrollTo({ top: top, behavior: 'smooth' });
          }
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["alvaro-testimonials"] && !Shopify.designMode) return;
  try {
    (function () {
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    ready(function () {
      document.querySelectorAll('.alvaro-testimonials').forEach(function (root) {
        var track = root.querySelector('[data-testimonials-track]');
        var cards = Array.prototype.slice.call(root.querySelectorAll('[data-testimonials-card]'));
        var dotsWrap = root.querySelector('[data-testimonials-dots]');
        var prevBtn = root.querySelector('[data-testimonials-prev]');
        var nextBtn = root.querySelector('[data-testimonials-next]');
        if (!track || !cards.length) return;

        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if ('IntersectionObserver' in window && !reduceMotion) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                io.unobserve(entry.target);
              }
            });
          }, { threshold: 0.15 });
          cards.forEach(function (card, i) {
            card.style.transitionDelay = (Math.min(i, 4) * 70) + 'ms';
            io.observe(card);
          });
        } else {
          cards.forEach(function (card) { card.classList.add('is-visible'); });
        }

        function step() {
          var gap = 14;
          var cs = getComputedStyle(track);
          var g = parseFloat(cs.columnGap || cs.gap);
          if (!isNaN(g)) gap = g;
          return cards[0].getBoundingClientRect().width + gap;
        }
        if (prevBtn) {
          prevBtn.addEventListener('click', function () {
            track.scrollBy({ left: -step(), behavior: 'smooth' });
          });
        }
        if (nextBtn) {
          nextBtn.addEventListener('click', function () {
            track.scrollBy({ left: step(), behavior: 'smooth' });
          });
        }

        if (dotsWrap) {
          cards.forEach(function (_, i) {
            var dot = document.createElement('span');
            dot.className = 'alvaro-testimonials__dot';
            if (i === 0) dot.classList.add('is-active');
            dotsWrap.appendChild(dot);
          });
          var dots = Array.prototype.slice.call(dotsWrap.children);

          function syncDots() {
            var trackRect = track.getBoundingClientRect();
            var center = trackRect.left + trackRect.width / 2;
            var closest = 0;
            var closestDist = Infinity;
            cards.forEach(function (card, i) {
              var r = card.getBoundingClientRect();
              var cardCenter = r.left + r.width / 2;
              var dist = Math.abs(cardCenter - center);
              if (dist < closestDist) { closestDist = dist; closest = i; }
            });
            dots.forEach(function (d, i) { d.classList.toggle('is-active', i === closest); });
          }

          var ticking = false;
          track.addEventListener('scroll', function () {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(function () {
              syncDots();
              ticking = false;
            });
          }, { passive: true });

          var resizeTimer = null;
          window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(syncDots, 150);
          }, { passive: true });

          // sincroniza el estado real una vez que el layout terminó de asentarse
          requestAnimationFrame(function () { requestAnimationFrame(syncDots); });
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
